import React from 'react'
import style from '../card.module.css'

function Geography() {
  return (
    <div className={style.syllabus_card}>
    <div>    
        <h3>Geography</h3>  
        <p>2 upcoming . 62 courses</p>      
    </div>   
        <p>Geography, Reading and more</p>      
    </div>
  )
}

export default Geography